// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/settlement/Settlement"),
  orderPrio: 80,
  iconType: "file-text",
  name: "settlements",
  subApps: [
    {
      name: "upload",
      requirePermission: "settlement:add"
    },
    {
      name: "published",
      requirePermission: "settlement:view"
    }
  ]
}: AppType)
